<template>
	<div class="container-fluid">
		<div class="row">
			<div class="col-12 col-xl-10">
				<div class="row align-items-center justify-content-between">
					<div class="col-12 col-lg-4">
						<h4 class="mb-4 pb-2 pt-2">New employee 
							<!--<router-link tag="a" :to="{ name : 'organization.providers.index'}" class="button icon-button ml-3">
								<img src="../../../assets/images/icons/solid/angle-left-white.svg" width="8" class="mr-1" />
								<span>Back</span>
							</router-link> -->
						</h4>
					</div><!--col-->
				</div><!--row-->
			</div><!--col-->
			<div class="col-12 col-xl-12">
				<form @submit.prevent="onSubmit">
					<label class="mb-2 h5 green">1. PERSONAL INFO</label>
					<div class="lightgray-content p-3 rounded mb-2">
						<div class="row">
							<div class="col-12 col-lg-4 col-xl-3">
								<div class="form-group input-content">
									<label>IMAGE</label>
									<vue-dropzone id="dropzone" 
									 class="mb-3 rounded" :options="dropzoneOptions"
									@vdropzone-removed-file="removeFile"
										@vdropzone-thumbnail="setImg"></vue-dropzone>
								</div>
							</div><!--col-->
							<div class="col-12 col-lg-4">
								<div class="form-group input-content">
									<label>Email</label>
									<input placeholder="Email" :disabled="user_role != 'csm'" type="text" v-model="provider_data.email" class="form-control" v-validate="'email'" name="email">
									<span class="input-error-msg">{{ errors.first('email') }}</span>
								</div>
								<div class="form-group input-content">
									<label>First name*</label>
									<input placeholder="First name" type="text" v-model="provider_data.first_name" class="form-control" v-validate="'required'" name="first_name">
									<span class="input-error-msg">{{ errors.first('first_name') }}</span>
								</div>
								<div class="form-group input-content">
									<label>Last name*</label>
									<input placeholder="Last name" type="text" v-model="provider_data.last_name" class="form-control" v-validate="'required'" name="last_name">
									<span class="input-error-msg">{{ errors.first('last_name') }}</span>
								</div>
								<!-- <div class="form-group input-content">
									<label>Gender</label>
									<v-select class="mb-2"  :searchable="false"  :options="[{ 'value' : '-', 'label' : '-'}, { 'value' : 'Male', 'label' : 'Male' }, { 'value' : 'Female', 'label' : 'Female' }]" v-model="provider_data.gender">
									</v-select>
								</div> -->
							</div><!--col-->
							<div class="col-12 col-lg-4">
								<!-- <div class="form-group input-content">
									<label>Birthday</label>
									<div class="row ml-0">
										<date-picker placeholder="Birthday" class="date_picker_new" v-model="provider_data.dob" :range="false" :format="'MM-DD-YYYY'" 
										:lang="{ formatLocale : { 'firstDayOfWeek' : 1 } }"
										:valueType="'YYYY-MM-DD'">
										</date-picker>

									</div>
									
									<!-- <datetime hidden-name="dob" placeholder="Birthday" v-model="provider_data.dob"></datetime> -->
									<!-- <span class="input-error-msg">{{ errors.first('dob') }}</span>
								</div> -->
								
								<div class="form-group input-content">
									<div class="row">
										<div class="col-5">
											<phone-country-code
											:rule="'not_required'"
											:section="'existin-provider'"
											:country_codes="country_codes"
											:form="provider_data"
											@countryInput="countryInput"/>
									
										</div>
										<div class="col-7">
											<label>Mobile number</label>
											<input placeholder="Mobile number" type="text" v-model="provider_data.phone" class="form-control" name="phone"
												v-validate="'required|min:8|max:10'">
											<span class="input-error-msg">{{ errors.first('phone') }}</span>
											<span class="input-error-msg" v-if="user_active">This Phone Number Exist In the System</span>
										</div>
									</div>
								</div>
								
								<div class="form-group input-content">
									<label>Preferred language</label>
									<!-- <v-select v-model="provider_data.preferred_language" :options="preferred_languages"></v-select> -->
									<multiselect v-model="provider_data.language" 
									label="value"
									:options="preferred_languages"></multiselect>
								</div>
							
							</div><!--col-->
						</div><!--row-->
						<div class="row">
							<div clasS="col-12">
								<label class="h6 mb-2">2. Management info</label>
							</div>
						</div>
						<!-- <div class="row">

							<div class="col-12 col-lg-3">
								<div class="form-group input-content">
									<label id="tooltip-approving-completion">RN approving completion</label>
						

									<v-select class="mb-2"  :searchable="true"  track-by="id" label="str"
										v-model="provider_data.manager_approving_the_hha_score" :options="approving_completions">
									</v-select>
								

								</div>
							</div>

							<div class="col-12 col-lg-3">
								<div class="form-group input-content">
									<label id="tooltip-supporting-rn">Learner support</label>

									<b-tooltip target="tooltip-supporting-rn" triggers="hover">
										<div class="tooltip-subrole">
											Learner Support-Choose the individual who will be replying to learner's questions about the training (we highly suggest you choose Nevvon).
									    </div>
								   </b-tooltip>

									<v-select class="mb-2"  :searchable="true"  track-by="id" label="str"
										v-model="provider_data.supporting_rn" :options="supporting_rn">
									</v-select>
								
									<span class="input-error-msg">{{ errors.first('supporting_rn') }}</span>

								</div>
							</div>
							<div class="col-12 col-lg-3">
								<div class="form-group input-content">
									<label id="tooltip-coordinator">Coordinator</label>

									<b-tooltip target="tooltip-coordinator" triggers="hover">
										<div class="tooltip-subrole">
									    	Choose the individual who will keep track of the learner's progress daily. This individual will be the most active in the platform.
									    </div>
								   </b-tooltip>

									<v-select class="mb-2"  :searchable="true"  track-by="id" label="str"
									v-model="provider_data.coordinator" :options="coordinators">
									</v-select>
									
									<span class="input-error-msg">{{ errors.first('coordinator') }}</span>

								</div>
							</div>
							<div class="col-12 col-lg-3">
								
								<div class="form-group input-content">
									<label id="tooltip-agency-manager">Agency manager</label>

									<b-tooltip target="tooltip-agency-manager" triggers="hover">
										<div class="tooltip-subrole">
									    	This individual is typically a high-level manager who can view progress but does not check every day.
									    </div>
								   </b-tooltip>

									<v-select class="mb-2"  :searchable="true"  track-by="id" label="str"
									v-model="provider_data.lhcsa_manager" :options="managers">
								</v-select>
									
									<span class="input-error-msg">{{ errors.first('lhcsa_manager') }}</span>


								</div>
							</div>
						</div> -->

						<div class="row">
							<div class="col-12 col-md-6 col-xl-3">
								<div class="form-group input-content">
									<label>Employment Date*</label>
									<date-picker class="date_picker_new" v-model="provider_data.onboard_date"  name="onboard_date" :range="false" :format="'MM-DD-YYYY'" 
										:placeholder="'Employment Date*'" 
										v-validate="'required'"
										:lang="{ formatLocale : { 'firstDayOfWeek' : 1 } }"
										:valueType="'YYYY-MM-DD'"></date-picker>
									<span class="input-error-msg">{{ errors.first('onboard_date') }}</span>
								</div>
							</div><!--col-->
							<div class="col-12 col-md-6 col-xl-3">
								<div class="form-group input-content">
									<label>Employee number</label>
									<input placeholder="Employee number" type="text"  class="form-control" name="employer_number"
										v-model="provider_data.employer_number" >
									<span class="input-error-msg">{{ errors.first('employer_number') }}</span>
								</div>
							</div><!--col-->

							<div class="col-12 col-md-6 col-xl-3">
								<div class="input-content">
									<label>Discipline<template v-if="discipline_mandatory == 1">*</template></label>
									<v-select class="mb-2 v-select-no-height discipline"  :searchable="true" 
									multiple track-by="id" label="name" name="organization_discipline_id" allowClear="true"
									v-model="provider_data.organization_discipline_ids"
												:options="disciplines" v-validate="discipline_mandatory == 1 ? 'required' : '' " >
									</v-select>
									<span class="input-error-msg">{{ errors.first('organization_discipline_id') }}</span>
								</div>
							</div>
							<div class="col-12 col-md-6 col-xl-3">
								<div class="input-content">
									<label>Location<template v-if="location_mandatory == 1">*</template></label>
									<v-select class="mb-2"  :searchable="true"  track-by="id" label="name"  allowClear="true"  name="organization_location_id"
									@input="locationChanged($event)"
											v-model="provider_data.organization_location_id" :options="locations"
											v-validate="location_mandatory == 1 ? 'required' : '' " >
									</v-select>
									<span class="input-error-msg">{{ errors.first('organization_location_id') }}</span>
								</div>
							</div>
							<div class="col-12 col-md-6 col-xl-3">
								<div class="input-content" :class="{'input-disabled not-allowed': !provider_data.organization_location_id.children}">
									<label>Sub Location<template v-if="location_mandatory == 1">*</template></label>
									<v-select class="mb-2"  :searchable="true"  track-by="id" label="name"  allowClear="true"  name="organization_sub_location_id"
											v-model="provider_data.sub_location" :options="sub_location_list"
											>
									</v-select>
									<span class="input-error-msg">{{ errors.first('organization_location_id') }}</span>
								</div>
							</div>
						</div><!--row-->

					</div>
					<div class="text-right">
						<div class="checkbox-container squared mb-2">
							<input id="checkbox-send-welcome-sms" type="checkbox" v-model="provider_data.send_welcome_sms"/>
							<label for="checkbox-send-welcome-sms" style="width:auto;font-size:13px;">Notify aid vía SMS</label>
						</div>
					</div>
					<div class="text-right mt-2 mb-5">
						<button type="submit" class="button large-button">Submit</button>
					</div>
				</form>
			</div><!--col-->
		</div><!--row-->
	</div>
</template>

<script>
import SubLocationSelection from '../../shared/inputs/SubLocationSelection'
import { API_BASE } from '../../../config'
import PhoneCountryCode from '../../shared/inputs/PhoneCountryCode'
export default {
	props:['share_view','shared_phone'],
	components:{
			PhoneCountryCode,
			SubLocationSelection
	},
	data : function(){
		return {
			user_role:'',
			show_supporting_note : false,
			provider_data : {
				email : '',
				ssn : '',
				first_name : '',
				last_name : '',
				// dob: '',
				// gender: '',
				language: '',
				phone: '',
				image : null,
				hha_registry_number : '',
				employer_number : '',
				country_code : '',
				send_welcome_sms : true,
				organization_discipline_ids:[],
				sub_location:'',
				organization_location_id:''
			},
			preferred_languages : [],
			dropzoneOptions: {
				url : API_BASE,
				thumbnailWidth: 50,
				maxFilesize: 4,
				maxFiles : 1,
				addRemoveLinks : true,
				headers : {
					'Autrollization' : localStorage.getItem('token')
				},
				autoProcessQueue : false
		    },
		    country_codes : [],
		    approving_completions : [],
			supporting_rn : [],
			coordinators : [],
			managers : [],
			disciplines : [],
			selected_disciplines:[],
			locations : [],
			location_mandatory : false,
			discipline_mandatory : false,
			status:'',
			user_active: false,
		}
	},
	created : function(){
		this.user_role = this.$store.getters.getRole
		console.log(this.$route.query);
		if(this.$route.query.country_code){
			this.provider_data.country_code = '+' + this.$route.query.country_code
		}
		// if(this.$route.query.country_code){
		// 	this.provider_data.country_code_ = {
		// 		label : '+' + this.$route.query.country_code,
		// 		value : '+' + this.$route.query.country_code
		// 	}
		// }

		if(this.$route.query.phone){
			this.provider_data.phone = this.$route.query.phone;
		}
		if(this.share_view){
			this.provider_data.phone = this.shared_phone.phone
			this.provider_data.country_code =  this.shared_phone.country_code
		}

		this.getPreferredLanguages();	
		this.getCountries();
		this.getSubroles();
		this.getDisciplines();
		this.getLocations();
		this.getMyOrganization();
	},
	computed : {
		sub_location_list: function(){
			if(this.provider_data.organization_location_id.children){
				return this.provider_data.organization_location_id.children
			}else{
				return []
			}
		}
	},
	watch: {
		'provider_data.phone': function(newVal, oldVal){
			if(this.user_active === true){
				this.user_active = false
			}	
		}
	},

	methods : {
		locationChanged: function(val){
			this.provider_data.sub_location = ''

		},
		countryInput: function(val){
				this.provider_data.country_code = val
		},
		getCountries : function(){
			this.$store.dispatch('getCountries', {}).then((res) => {
			
				this.country_codes = res.data.data;
			}).catch((error) =>{	
				console.log(error);
			});
		},
		onSubmit : function(){
			this.checkIfExists();
			if(this.user_active == false){
				this.$validator.validateAll().then((result) => {
					if(result){
						var params = this.provider_data
						// if(this.provider_data.gender){
						// 	this.provider_data.gender = this.provider_data.gender.value;
						// }
						
						// this.provider_data.country_code = this.provider_data.country_code.value;
						this.provider_data.send_welcome_sms = this.provider_data.send_welcome_sms ? 1 : 0;
						params.send_welcome_sms = this.provider_data.send_welcome_sms ? 1 : 0;

						if(typeof this.provider_data.country_code == 'object'){
            				this.provider_data.country_code = this.provider_data.country_code.value;
            				params.country_code = this.provider_data.country_code.value;

						}

						if(this.provider_data.organization_discipline_ids){
							// 	this.provider_data.organization_discipline_ids = this.provider_data.organization_discipline_ids.map(elem =>{ return elem.id 
							// })
								params.organization_discipline_ids = this.provider_data.organization_discipline_ids.map(elem =>{ return elem.id 
							})
						}
					

						// if(this.provider_data.lhcsa_manager.id)
						// 	this.provider_data.manager_id = this.provider_data.lhcsa_manager.id;

						// if(this.provider_data.coordinator.id)
						// 	this.provider_data.coordinator_id = this.provider_data.coordinator.id;

						// if(this.provider_data.manager_approving_the_hha_score.id)
						// 	this.provider_data.approving_id = this.provider_data.manager_approving_the_hha_score.id;

						// if(this.provider_data.supporting_rn.id)
						// 	this.provider_data.supporting_id = this.provider_data.supporting_rn.id;
						

						if(this.provider_data.language){
							params.language = params.language.key;
						}
						//user proper location ID
						if(this.provider_data.sub_location == null || this.provider_data.sub_location == ''){
							params.organization_location_id = this.provider_data.organization_location_id;
							delete params['sub_location'];
						}else{
							params.organization_location_id = this.provider_data.sub_location;
							delete params['sub_location'];
							
						}
						

						// if user csm add organization_id
						if(this.user_role === 'csm'){
							this.provider_data.organization_id =  this.$route.query.agency_id
							params.organization_id =  this.$route.query.agency_id
						}
						if(this.share_view){
							this.$emit('onSubmitNewProvider', this.provider_data)
							return
						}
					
						this.$store.dispatch('createProvider', params).then((res) => {
							if(this.user_role === 'csm'){
								this.$router.push({ name: 'csm.providers.detail', params : { id : res.data.provider.id }, query:{agency_id : this.$route.query.agency_id} });
							}else{
								this.$router.push({ name: 'organization.providers.detail', params : { id : res.data.provider.id } });
							}
						}).catch((error) => {
							this.provider_data.language = this.preferred_languages.find(elem =>  elem.key == params.language)
						});
					}
				});
			}
		},
		setImg : function(file, dataUrl){
			this.provider_data.image = dataUrl;
		},
		removeFile: function(){
			this.provider_data.image = null
		},
		getPreferredLanguages : function(){
			this.preferred_languages = []
			var params = { filters:{available_for_users: 1} };
			this.$store.dispatch('getLanguages', params).then((res) => {
				for(let i in res.data.data){
					if(this.provider_data.language == res.data.data[i][0].code_2){
						this.provider_data.language = {key:res.data.data[i][0].code_2, value:res.data.data[i][0].name}
					}
					this.preferred_languages.push({key:res.data.data[i][0].code_2, value:res.data.data[i][0].name})
				}
			}).catch((error) => {
				console.log(error);
			});
		},
		getSubroles : function(){
			return
			if(this.user_role === 'csm'){
				var params = {
					id : this.$route.query.agency_id,
				}
			}else{
				var params = {
					id : '_'
				}
			}

			this.$store.dispatch('getOrganizationSubroles', params).then((res) => {
				
				for(var i in res.data.data){
					var obj = res.data.data[i];

					switch(obj.type){
						case 'manager' :
							this.managers.push(obj); 

							if(obj.is_default)
								this.provider_data.lhcsa_manager = obj;
							break;
						case 'supporting_rn' :
							this.supporting_rn.push(obj); 

							if(obj.is_default)
								this.provider_data.supporting_rn = obj;

							break;
						case 'coordinator' :
							this.coordinators.push(obj); 

							if(obj.is_default)
								this.provider_data.coordinator = obj;

							break;
						case 'approve_rn' : 
							this.approving_completions.push(obj); 

							if(obj.is_default)
								this.provider_data.manager_approving_the_hha_score = obj;

							

							break;
					}


				}
			}).catch((error) => {
				console.log(error);
			});
		},

		getDisciplines : function(){
			if(this.user_role === 'csm'){
				var params = {
					id : this.$route.query.agency_id,
					filters : {
						type : 'discipline'
					}
				}
			}else{
				var params = {
					id : '_',
					filters : {
						type : 'discipline'
					}
				}
			}

			this.$store.dispatch('getTaxonomyValues', params).then((res) => {
				this.disciplines = res.data.data;
			}).catch((error) => {
				console.log(error);
			});
		},

		getLocations : function(){
			let id = '_'
			this.user_role === 'csm' ? id = this.$route.query.agency_id : id = id
			var params = {
				id : id,
				filters : {
					type : 'location',
					page_loading : false
				}
			}

			this.$store.dispatch('getTaxonomyValues', params).then((res) => {
				this.locations = res.data.data;
			}).catch((error) => {
				console.log(error);
			});
		},
		getMyOrganization : function(){

			this.$store.dispatch('getMyOrganization', {}).then((res) => {
				this.location_mandatory = res.data.organization.location_mandatory;
				this.discipline_mandatory = res.data.organization.discipline_mandatory;
			}).catch((error) => {
				console.log(error);
			});
		},

		checkIfExists : function(){
				if(this.user_role === 'csm'){
					var params = {
						organization_id:this.$route.query.agency_id,
						country_code : this.provider_data.country_code.value,
						phone : this.provider_data.phone,
						filters : {
							page_loading : false
						}
					}
				}else{
					var params = {
						country_code : this.provider_data.country_code.value,
						phone : this.provider_data.phone,
						filters : {
							page_loading : false
						}
					}
				}
				this.$store.dispatch('getStatusInOrganization', params).then((response) => {
					this.status = response.data.status;
					if(this.status == 'NOT_EXISTS_IN_SYSTEM'){	
						this.user_active = false
						return true
					}else{
						this.user_active = true
						return false
					}
				}).catch((error) => {
					console.log(error);
				})

			},
	}
}
</script>


// WEBPACK FOOTER //
// src/components/organizations/providers/OrganizationProviderCreateComponent.vue